import { User, Hand, MessageCircle, Check, ThumbsUp } from "lucide-react";

export const HumanLoopSection = () => {
  return (
    <section className="py-20 bg-[#f0f0f0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-8 mb-4">
          <img 
            src="/maia-human.svg" 
            alt="Maia Mail assistant with Human in the Loop" 
            className="w-[70px] h-auto float"
          />
          <h2 className="text-3xl font-bold">Maia with "Human in the Loop": You're Always in Control!</h2>
        </div>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Maia enhances your email communication while keeping you in complete control of the process. No automation surprises, just powerful AI assistance when you need it.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <User className="w-12 h-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-3">Complete Control</h3>
            <p className="text-gray-600">
              With Maia you will always be in charge of the communication. Define custom instructions for your assistants and modify any response to your liking before sending it.
            </p>
          </div>

          <div className="text-center p-6">
            <Hand className="w-12 h-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-3">Final Approval</h3>
            <p className="text-gray-600">
              Nothing gets sent without your review and approval. You're always the one who hits the send button, ensuring every response meets your standards.
            </p>
          </div>

          <div className="text-center p-6">
            <MessageCircle className="w-12 h-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-3">Interactive Refinement</h3>
            <p className="text-gray-600">
              Need adjustments? Simply add your comments and regenerate. The AI adapts to your feedback, creating the perfect response.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8 max-w-3xl mx-auto">
          <div className="text-center p-6">
            <Check className="w-12 h-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-3">Selective Processing</h3>
            <p className="text-gray-600">
              Choose which emails deserve AI assistance. No automatic replies - you maintain full control over your communication strategy.
            </p>
          </div>

          <div className="text-center p-6">
            <ThumbsUp className="w-12 h-12 mx-auto mb-4 text-primary" />
            <h3 className="text-xl font-semibold mb-3">Enhanced Efficiency</h3>
            <p className="text-gray-600">
              Combine human insight with AI capabilities. Get the best of both worlds - human judgment with AI-powered efficiency.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
